import { motion } from 'motion/react'
import { useRef } from 'react'
import { m } from '~/paraglide/messages'
import { BellIcon } from './icons/bell'
import { StarIcon } from './icons/star'
import { UnlockIcon } from './icons/unlock'

export function ReminderPage(props: { next: () => void }) {
  const buttonGuardRef = useRef(false)
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="relative mx-auto h-full max-w-[640px] space-y-12 overflow-y-auto px-8 pb-48 pt-[120px]"
      onAnimationComplete={() => {
        buttonGuardRef.current = true
      }}
    >
      <h1
        className="whitespace-pre-line px-4 text-center text-2xl font-bold text-white"
        dangerouslySetInnerHTML={{
          __html: m
            .subscription_walkthrough_p3_title()
            .replace('[%2$s]', 'color: #2AFD00;'),
        }}
      />

      <div className="relative mt-5 flex flex-col gap-8 px-6 text-white">
        <DecoBar className="pointer-events-none absolute left-[41px] top-3" />

        <div className="relative flex gap-[10px] pl-[6px]">
          <div className="size-[30px] shrink-0">
            <UnlockIcon />
          </div>
          <div className="flex-1 space-y-1">
            <h2 className="font-bold">
              {m.subscription_walkthrough_p3_today()}
            </h2>
            <p className="text-sm">
              {m.subscription_walkthrough_p3_today_note()}
            </p>
          </div>
        </div>
        <div className="relative flex gap-[10px] pl-[6px]">
          <div className="size-[30px] shrink-0">
            <BellIcon />
          </div>
          <div className="flex-1 space-y-1">
            <h2 className="font-bold">
              {m.subscription_walkthrough_p3_1_day_before_trail()}
            </h2>
            <p className="text-sm">
              {m.subscription_walkthrough_p3_1_day_before_trail_note()}
            </p>
          </div>
        </div>
        <div className="relative flex gap-[10px] pl-[6px]">
          <div className="size-[30px] shrink-0">
            <StarIcon />
          </div>
          <div className="flex-1 space-y-1">
            <h2 className="font-bold">
              {m.subscription_walkthrough_p3_trail_end()}
            </h2>
            <p className="text-sm">
              {m.subscription_walkthrough_p3_trail_end_note()}
            </p>
          </div>
        </div>
      </div>

      <div
        className="fixed bottom-0 left-0 right-0 bg-[#001721] px-6 pb-12 pt-3"
        style={{
          boxShadow: '0 -3px 3px 0 rgba(255, 255, 255, 0.20)',
        }}
      >
        <div className="mx-auto max-w-[640px] space-y-3">
          <p className="text-center text-[#FFFFFFE6]">
            {m.subscription_walkthrough_p1_trial_fee()}
          </p>

          <button
            className="group h-[52px] w-full rounded-xl p-px [background-image:linear-gradient(180deg,#C5FF70_0%,#69FF78_45%,#30D3FF_100%)]"
            onClick={() => {
              if (!buttonGuardRef.current) return
              props.next()
              buttonGuardRef.current = false
            }}
          >
            <span className="flex h-full w-full items-center justify-center rounded-[11px] font-bold text-[#176361] [background-image:linear-gradient(106deg,#C5FF70_13%,#30D3FF_97%)] group-active:[background-image:linear-gradient(90deg,#94D66E_0%,#2BB8D3_100%)]">
              {m.subscription_view_complete_benefit()}
            </span>
          </button>
        </div>
      </div>
    </motion.div>
  )
}

function DecoBar(props: { className?: string }) {
  return (
    <svg
      width="8"
      height="331"
      viewBox="0 0 8 331"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <rect width="8" height="331" fill="url(#paint0_linear_160_21683)" />
      <defs>
        <linearGradient
          id="paint0_linear_160_21683"
          x1="-0.000120468"
          y1="-105.471"
          x2="0.388971"
          y2="273.776"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#82D200" />
          <stop offset="0.505653" stopColor="#0EBC73" />
          <stop offset="0.8" stopColor="#08C1F3" stopOpacity="0.66" />
          <stop offset="1" stopColor="#08C1F3" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
